import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UserSessionResponse, UserHttpService, ModifiedActionStatus, ActionEventHandler } from 'apps/website/src/app/utils/public-api';
import { DataFieldType } from '../../../common-ui/table-ui/table-ui.component';

@Component({
  selector: 'intrasense-table-actions',
  templateUrl: './table-actions.component.html',
  styleUrls: ['./table-actions.component.scss']
})
export class TableActionsComponent implements OnInit {
  @Input('row') row: any;
  @Input('item') item: any;
  @Input('index') i: any;
  @Output() onBtnClick = new EventEmitter();
  ACTION_EVENT = ModifiedActionStatus;
  ACTION_EVENT_HANDLER = ActionEventHandler;
  userDetail!: UserSessionResponse;
  
  constructor(private userHttpService: UserHttpService) { }

  ngOnInit(): void {
    this.userDetail = this.userHttpService.getUserInfo;
  }
  
  click(index: number, type: DataFieldType, actionEvent: string) {
    this.onBtnClick.emit({index$: index, type$: type, actionEvent$: actionEvent})
  }
}
